interface ChevronRightIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}

function ChevronRightIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  ...rest
}: ChevronRightIconProps) {
  return (
    <span className={className} onClick={onClick} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 21) / 20}
        viewBox='0 0 20 21'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.91107 4.91009C7.23651 4.58466 7.76414 4.58466 8.08958 4.91009L13.0896 9.91009C13.415 10.2355 13.415 10.7632 13.0896 11.0886L8.08958 16.0886C7.76414 16.414 7.23651 16.414 6.91107 16.0886C6.58563 15.7632 6.58563 15.2355 6.91107 14.9101L11.3218 10.4993L6.91107 6.0886C6.58563 5.76317 6.58563 5.23553 6.91107 4.91009Z'
        />
      </svg>
    </span>
  );
}

export default ChevronRightIcon;
